export const link = {
  color: 'black',
}

export const rugCardsSegment = {
  padding: 30,
}
